import React from "react";
import { Hover } from "./Hover";
import { Default } from "./Default";
import PropTypes from "prop-types";

export function Tooltip(props) {
  return props.hover ? <Hover onClick={props.onClick} /> : <Default />;
}

Tooltip.propTypes = {
  /**
   * callback function triggered on click hover tooltip
   */
  onClick: PropTypes.func,
  /**
   * bool specifies hover state of component
   */
  hover: PropTypes.bool,
};
